<template>
    <div class="racunovodstvo-nalozi">
        <DataLoader :is_on="loading" />
        <div class="opening-folder">
            <div class="open-folder-line">
                <div class="open-folder-line-left">
                    <div class="naplata-filters">
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{on, attrs}">
                                <v-text-field
                                    v-model="dateRangeText"
                                    readonly
                                    clearable
                                    :label="$t('billing_page.filters.f1')"
                                    append-icon="mdi-calendar"
                                    v-bind="attrs"
                                    @click:append="menu1 = !menu1"
                                    v-on="on"
                                    class="case-date-picker rocista-date-picker"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="hr"
                                v-model="date_range"
                                range
                                no-title
                                :pickerDate.sync="pickerDate"
                            >
                            </v-date-picker>
                        </v-menu>
                        <CustomDropdown
                            :id="'drop_types'"
                            class="wider"
                            :additional_classes="'phase'"
                            v-model="is_invoiced"
                            :drop_items="statusi"
                        />
                        <!--<CustomDropdown
                            :id="'drop_odvjetnici'"
                            class="wider"
                            :additional_classes="'phase'"
                            v-model="selektirana_osoba"
                            :drop_items="all_odvjetnici"
                            :init_text="$t('billing_page.filters.f3')"
                        />
                        <CustomDropdown
                            :id="'drop_foldery_types'"
                            class="wider"
                            :additional_classes="'phase'"
                            v-model="selektirani_tip_foldera"
                            :drop_items="all_doc_types"
                            :init_text="$t('billing_page.filters.f4')"
                        /> -->
                        <!-- <div class="generiraj-rocisnik-button" @click="openReport()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none"><path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span>Izvještaj</span>
                      </div> -->
                    </div>
                </div>
            </div>
        </div>
        <custom-spinner v-if="fetching" />
        <div v-else class="racunovodstvo-wrapper troskovnik-report-edit">
            <div class="racunovodstvo-left event-list-wrapper troskovnik-report-edit-left">
                <div v-if="nalozi.length==0" class="case-kalendar-event events-tab-view">
                    <div class="kalendar-event-details">
                        <div class="case-kalendar-event-empty">
                            {{ $t("racunovodstvo_nalozi.no_nalozi") }}
                        </div>
                    </div>
                </div>
                <div v-for="(nalog, key) in finalni_arr_prikaza" :key="key" 
                    :class="[ 'case-kalendar-event events-tab-view', chosen_nalog && nalog.id_troskovnik == chosen_nalog.id_troskovnik ? 'active' : '', ]" 
                    @click="setNalogView(nalog)" 
                >
                    <div class="event-type-wrapper">
                        <div v-if="!nalog.is_invoiced" :class="'vrsta-eventa event-red'">
                            {{ $t("racunovodstvo_nalozi.not_invoiced") }}
                        </div>
                        <div v-else :class="'vrsta-eventa event-green'">
                            {{ $t("racunovodstvo_nalozi.invoiced") }}
                            <br>
                            {{ nalog.invoicing_timestamp ? `${getDate(nalog.invoicing_timestamp)}` : '' }}
                            <!-- {{ nalog.invoicing_timestamp ? `${getTime(nalog.invoicing_timestamp)}` : '' }} -->
                        </div>
                    </div>
                    <div class="kalendar-event-details">
                        <div class="kalendar-event-title">{{ nalog.name }}</div>
                        <div class="kalendar-event-case-name underline-item" >
                            {{ nalog.predmet.ime_predmeta }}
                        </div>
                        <div class="nalog-person">
                            <span class="person-title">
                                {{ $t("racunovodstvo_nalozi.holder") }}:
                            </span>
                            <span class="">
                                {{
                                    getAccountHolder(
                                        nalog.predmet
                                            .predmet_odvjetnik_connector
                                    )
                                }}
                            </span>
                        </div>
                        <div class="nalog-person">
                            <span class="person-title">
                                {{ $t("racunovodstvo_nalozi.date_created") }}:
                            </span>
                            <span class="">
                                {{ getDate(nalog.time_created) }}
                            </span>
                        </div>
                        <div v-if="nalog.is_invoiced" class="nalog-person">
                            <span class="person-title">
                                {{ $t('racunovodstvo_nalozi.racun_num') }}:
                            </span>
                            <span class="">
                                {{ nalog.rn_number }}
                            </span>
                        </div>
                        <div v-if="nalog.billing_types.id == 4" @click="openBreakdown()" class="kalendar-event-case-name nalog-breakdown underline-item" >
                            <b>{{ $t('billing_management.accounting_orders.open_service_specification') }}</b>
                        </div>
                        <div class="buttons-wrapper">
                            <div
                                class="print-button icon-button"
                                @click="openNalog(nalog)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" id="SVGDoc" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" > <defs></defs> <desc>Generated with Avocode.</desc> <g> <g> <title>view_icon</title> <path fill="#2b2b41" d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z" fill-opacity="1" ></path> </g> </g> </svg>
                                {{ $t("racunovodstvo_nalozi.open") }}
                            </div>
                            <div
                                class="print-button icon-button"
                                @click="downloadNalog(nalog)"
                                v-if="downloading != nalog.id_troskovnik"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none" > <path fill-rule="evenodd" clip-rule="evenodd" d="M6.6975 0C5.89894 0 5.23277 0.648667 5.16304 1.49419C5.01724 3.26199 4.98035 5.03769 5.05247 6.80992C4.96541 6.81611 4.87837 6.82256 4.79135 6.82928L3.25379 6.94843C2.27103 7.02459 1.72166 8.18923 2.25222 9.07179C3.38376 10.9539 4.84177 12.5902 6.54854 13.8933L7.16454 14.3636C7.66395 14.745 8.33665 14.745 8.83606 14.3636L9.45206 13.8933C11.1588 12.5902 12.6169 10.9539 13.7484 9.07179C14.2789 8.18923 13.7296 7.02459 12.7468 6.94843L11.2093 6.82928C11.1222 6.82256 11.0352 6.81611 10.9481 6.80992C11.0203 5.03768 10.9834 3.26199 10.8376 1.49418C10.7678 0.648661 10.1017 0 9.3031 0H6.6975Z" fill="black" /> <path d="M1.54839 15.0855C1.54839 14.6311 1.20177 14.2627 0.774192 14.2627C0.346618 14.2627 0 14.6311 0 15.0855V17.2798C0 18.3402 0.808779 19.1998 1.80645 19.1998H14.1935C15.1912 19.1998 16 18.3402 16 17.2798V15.0855C16 14.6311 15.6534 14.2627 15.2258 14.2627C14.7982 14.2627 14.4516 14.6311 14.4516 15.0855V17.2798C14.4516 17.4313 14.3361 17.5541 14.1935 17.5541H1.80645C1.66393 17.5541 1.54839 17.4313 1.54839 17.2798V15.0855Z" fill="black" /> </svg>
                                {{ $t("racunovodstvo_nalozi.download") }}

                            </div>
                            <div
                                class="print-button icon-button"
                                v-else
                            >
                                <div class="center-spinner">
                                    <svg class="dot-spin" viewBox="0 0 50 50">
                                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="print-button icon-button" @click="openInvoicing(nalog)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" > <g> <g> <path fill="#000" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" ></path> </g> </g> </svg>
                                {{ !nalog.is_invoiced ? $t("racunovodstvo_nalozi.izvrsi") : $t("racunovodstvo_nalozi.izvrsi_edit") }}
                            </div>
                        </div>
                    </div>
                </div>
                <Pagination v-show="nalozi.length != 0" ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="3" :ukupna_lista="nalozi"/>
            </div>
            <div class="racunovodstvo-right troskovnik-report-edit-right">
                <label class="form-label">
                    <span></span>
                </label>
                <div class="troskovnik-report-edit-wrapper">
                    <div
                        v-if="chosen_nalog"
                        :class="['pdf-troskovnik new-entry']"
                        v-html="getNalogHTML"
                    ></div>
                    <div v-else class="preview-msg">
                        {{ $t("racunovodstvo_nalozi.preview") }}
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="invoice_popup" width="564px">
            <v-card color="universal-vcard racunovodstvo-popup" :key="rk">
                <div v-if="chosen_nalog" class="universal-vdialog-title">
                    {{ !chosen_nalog.is_invoiced ? $t("racunovodstvo_nalozi.popup_title",{nalog:chosen_nalog.name}) : $t("racunovodstvo_nalozi.edit_invoice_title",{nalog:chosen_nalog.name}) }}
                </div>

                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateTextInvoicing" readonly :label="$t('racunovodstvo_nalozi.date_lbl')" append-icon="mdi-calendar" 
                        v-bind="attrs" @click="menu2 = !menu2" v-on="on" class="case-date-picker archive-date-picker"></v-text-field>
                    </template>
                    <v-date-picker locale="hr" :first-day-of-week="1" v-model="invoicing_date" no-title></v-date-picker>
                </v-menu>
                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="timeTextInvoicing" readonly :label="$t('racunovodstvo_nalozi.time_lbl')" append-icon="mdi-clock" 
                        v-bind="attrs" @click="menu3 = !menu3" v-on="on" class="case-date-picker archive-date-picker"></v-text-field>
                    </template>
                    <v-time-picker locale="hr" format="24hr" v-model="invoicing_time"></v-time-picker>
                </v-menu>
                <v-text-field v-model="racun_num" :label="$t('racunovodstvo_nalozi.racun_num')" class="case-date-picker archive-date-picker"></v-text-field>
                <form-files-upload
                    v-if="chosen_nalog"
                    :deleted_items.sync="chosen_nalog.deleted_privici"
                    :existing_items.sync="chosen_nalog.privici"
                    :new_items.sync="temp_privici"
                    :is_single_upload="true"
                    :can_download="true"
                    :title="$t('racunovodstvo_nalozi.racun_attach')"
                    :btn_title="$t('racunovodstvo_nalozi.racun_attach_add')"
                    @getFile="getGraphInvoice"
                />
                <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                    <div class="universal-vdialog-button vbutton-secondary" @click="invoice_popup = false">
                        {{ $t("repetitive.cancel") }} </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="finalizeInvoicing()">
                        {{ $t("repetitive.yes") }} </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import financial from "@/apiCallers/promise_handler_db/financial.js";
import admin from "@/apiCallers/promise_handler_db/admin.js";
import $ from "jquery";
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import moment from "moment";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import DataLoader from '@/components/generalComponents/DataLoader'
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";
import Pagination from "@/components/generalComponents/Pagination.vue";
import FormFilesUpload from '@/components/formElements/formFilesUpload.vue';

export default {
    components: {
        CustomDropdown,
        DataLoader,
        CustomSpinner,
        Pagination,
        FormFilesUpload,
    },
    data() {
        return {
            header_footer_data: {
                header_left: "<p></p>",
                header_right: "<p></p>",
                footer: "<p></p>",
            },
            statusi: this.$t("racunovodstvo_nalozi.statusi"),
            nalozi: [],
            chosen_nalog: null,
            menu1: false,
            menu2: false,
            menu3: false,
            invoicing_date:"",
            invoicing_time:"",
            racun_num:"",
            date_range: [],
            pickerDate: null,
            is_invoiced: null,
            invoice_popup: false,
            loading: false,
            fetching: false,
            finalni_arr_prikaza: [],
            downloading:null,
            snackbar: false,
            snackTimeout: 4000,
            snackText:'',
            temp_privici:[],
            is_hovering:false,
            rk:0,
        };
    },
    computed: {
        getNalogHTML() {
            const prepared_html = this.chosen_nalog.finished_html;
            const finished_html = $(prepared_html).find(".general-wrapper");
            const footer = $(prepared_html).find(".footer");
            const final = finished_html[0].outerHTML + footer[0].outerHTML;
            return final;
        },
        dateRangeText: {
            get() {
                var ret_date_string = [];
                this.date_range.forEach((p) => {
                ret_date_string.push(moment(p).format("l"));
                });
                return ret_date_string.join(" ~ ");
            },
            set(new_val) {
                // console.log(new_val)
                if (new_val == null) {
                this.date_range = [];
                }
            }
        },
        dateTextInvoicing() {
            return moment(this.invoicing_date).format("DD.MM.yyyy.");
        },
        timeTextInvoicing() {
            return this.invoicing_time;
        }
    },
    async created() {
        this.loading = true;
        await admin
            .getOrganizationInfo()
            .then((resp) => {
                this.header_footer_data = resp.data.troskovnik_header_footer;
            })
            .finally(() => {
                this.loading = false;
            });
        await this.getNalozi();
        this.setInitData()
    },
    methods: {
        openBreakdown(){
            setTimeout(() => {
                this.$store.state.breakdown_report_data = {
                    breakdown:this.chosen_nalog.breakdown_satnice,
                    predmet_data:this.chosen_nalog.predmet,
                    punomocnik:this.chosen_nalog.edit_structure.punomoćnik_osoba,
                    naziv_dokumenta: this.chosen_nalog.name,
                }
                this.$router.push('/breakdown-report')
            }, 10);
        },
        setInitData() {
            const today = moment(Date.now())
            const now_date = today.format("yyyy-MM-DD");
            const now_time = today.format("HH:mm");
            this.invoicing_date = now_date;
            this.invoicing_time = now_time;
            this.racun_num = "";
        },
        setNalogView(nalog) {
            this.chosen_nalog = nalog;
            this.chosen_nalog.privici = this.chosen_nalog.graph_invoice && this.chosen_nalog.graph_invoice.id ? [this.chosen_nalog.graph_invoice] : []
            this.chosen_nalog.deleted_privici = [];
        },
        openInvoicing(nalog) {
            this.setNalogView(nalog);

            if (this.chosen_nalog.is_invoiced) {
                this.invoicing_date = moment(this.chosen_nalog.invoicing_timestamp).format("yyyy-MM-DD");
                this.invoicing_time = moment(this.chosen_nalog.invoicing_timestamp).format("HH:mm");
                this.racun_num = this.chosen_nalog.rn_number;
            }
            this.invoice_popup = true;
        },
        async finalizeInvoicing() {
            this.loading = true;
            this.accessToken = this.$store.state.aToken;
            this.invoice_popup = false;
            try {
                const formData = new FormData();
                for (let i = 0; i < this.temp_privici.length; i++) {
                    formData.append("files", this.temp_privici[i]);
                }
                if (this.temp_privici.length>0) {
                    this.chosen_nalog.deleted_privici = this.chosen_nalog.privici;
                }
                const nalog = {
                    invoice_id:this.chosen_nalog.id_troskovnik,
                    is_invoiced:true,
                    invoicing_time:`${moment(this.invoicing_date).format('yyyy-MM-DD')}T${this.invoicing_time}`,
                    person:this.$store.state.logged_in_user.uid,
                    racun_num:this.racun_num,
                    root_racuni:this.chosen_nalog.predmet.root_racuni,
                    deleted_privici:this.chosen_nalog.deleted_privici
                };
                formData.append("nalog",JSON.stringify(nalog))
                const resp = await financial.setInvoicedStatus(formData);
                await this.getNalozi();
            } catch (error) {
                console.error(error);
            }
            finally {
                this.loading = false;
                this.temp_privici = [];
            }
        },
        async getGraphInvoice(graph_invoice,name) {
            await financial.getGraphInvoice(graph_invoice).then((resp) => {
                //pripremanje download linka
                var link = document.createElement("a");
                link.setAttribute("href", resp.data.webUrl);
                link.setAttribute("target", "_blank");
                link.setAttribute("download", this.chosen_nalog.rn_number ? this.chosen_nalog.rn_number : 'Račun-'+this.chosen_nalog.rn_number);
                link.click();
            })
        },
        getDate(date) {
            return moment(date).format("DD.MM.yyyy.");
        },
        getTime(date) {
            return moment(date).format("HH:mm:ss");
        },
        async getNalozi() {
            this.chosen_nalog = null;
            this.fetching = true;
            var start_date = null;
            var end_date = null;
            let sorted_date_range = [...this.date_range]
            sorted_date_range.sort((a, b) => new Date(a) - new Date(b))
            if (sorted_date_range.length > 0) {
                start_date = sorted_date_range[0];
                if (sorted_date_range.length > 1) {
                end_date = sorted_date_range[1];
                }
                else {
                end_date = sorted_date_range[0];
                }
            }
            await financial.getAllNalozi(start_date,end_date,this.is_invoiced).then((resp) => {
                this.nalozi = resp.data.map((n)=>({...n,deleted_privici:[],privici:[]}));
                setTimeout(() => {
                    this.$refs.paginat.calculatePageNumber();
                    this.$refs.paginat.paginirajOdabrane();
                }, 10);
            })
            .finally(() => {
                this.fetching = false;
            });
        },
        getAccountHolder(odvjetnici) {
            const found = odvjetnici.find((o) => o.status_id == 2);
            return found
                ? `${found.odvjetnik.ime} ${found.odvjetnik.prezime}`
                : "-";
        },
        openNalog(nalog) {
            this.$store.state.troskovnik_pdf_view = true;
            this.$store.state.troskovnik_data = nalog.recreate_pdf_structure;
            this.$router.push("/troskovnik-report");
        },
        async downloadNalog(nalog) {
            this.downloading = nalog.id_troskovnik;
            this.creating_report = true;
            let html_to_print = nalog.finished_html;
            let footer = $(html_to_print).find(".footer");
            footer.css({"font-family": "'Roboto', sans-serif;","width":"100%","-webkit-print-color-adjust":"exact","color": "#828282","background-color": "#fafafa","padding": "4px 0 4px 0","text-align": "center","font-size": "8px","line-height": "4px", "margin":"0!important"});
            const final_footer = '<style>#header, #footer { padding: 0 !important; }</style>'+footer[0].outerHTML;
            html_to_print = html_to_print.replace(
                'class="mainH',
                'class="mainH printing'
            );
            await ms_calendar
                .printVertical(html_to_print, final_footer)
                .then(async (resp) => {
                    var newBlob = new Blob([resp.data], {
                        type: "application/pdf",
                    });
                    var data = window.URL.createObjectURL(newBlob);
                    var link = document.createElement("a");
                    link.href = data;
                    link.download =
                        this.$t("reports.naplata.file_name") +
                        moment().format("l") +
                        ".pdf";
                    link.click();
                    setTimeout(function() {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        window.URL.revokeObjectURL(data);
                    }, 100);
                    this.creating_report = false;
                })
                .catch((_err) => {
                    this.creating_report = false;
                })
                .finally(()=>this.downloading=null);
        },
    },

    watch: {
        date_range: function () {
            this.getNalozi();
        },
        is_invoiced: function () {
            this.getNalozi();
        },
        invoice_popup: function () {
            this.rk++;
            if (!this.invoice_popup) {
                this.setInitData();
            }
        }
    },

    mounted() {},
};
</script>
